export default class VincularPersonalACurso {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(payload) {
    try {
      const result = await this.#repository.vincularPersonalACurso(payload)
      return result
    } catch (error) {
      throw error
    }
  }
}
